import { Box } from '@chakra-ui/react'
import RpTable from './components/RpTable/RpTable'

const Rp = () => {
  return (
    <Box>
        <RpTable/>
    </Box>
  )
}

export default Rp